import React from 'react';
import i18n from 'i18next';
import styles from '../Vehicles.module.scss';
import removeIcon from '../../../img/remove_icon.svg';
import editIcon from '../../../img/edit_icon.svg';
import { faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import VehicleModal from "../VehicleModal";

export const CreateVehicle = (title, createHandler, createVehicleDialogOpen, setCreateVehicleDialogOpen, manufacturers) => {
  return (
    <VehicleModal
      open={createVehicleDialogOpen}
      modalHeaderText={title}
      vehicle={null}
      manufacturers={manufacturers}
      submitHandler={createHandler}
      trigger={(
        <a
          href="!#" rel="noopener noreferrer"
        >
          <button
            type="button"
            className={styles.createIcon}
            onClick={(e) => {
              e.preventDefault();
              setCreateVehicleDialogOpen(true);
            }}
            aria-label="create vehicle"
          >
            <FontAwesomeIcon icon={faPlusCircle} color="#2957A4" size="2x" />
          </button>
        </a>
      )}
    />
  )
}

export const EditVehicle = (title, editHandler, editVehicleDialogOpen, setEditVehicleDialogOpen, manufacturers, row) => {
  return (
    <VehicleModal
      open={editVehicleDialogOpen}
      modalHeaderText={title}
      vehicle={row}
      manufacturers={manufacturers}
      submitHandler={editHandler}
      trigger={(
        <a
          href="!#" rel="noopener noreferrer"
        >
          <button
            type="button"
            className={styles.editIcon}
            onClick={(e) => {
              setEditVehicleDialogOpen(true);
              e.preventDefault();
            }}
            aria-label="edit vehicle"
          >
            <img alt="edit vehicle" src={editIcon} />
          </button>
        </a>
      )}
    />
  )
}

export const RemoveVehicle = (row, removeHandler) => (
  <button
    type="button"
    className={styles.removeIcon}
    onClick={() => removeHandler(row)}
    aria-label="remove traveler"
  >
    <img alt="remove traveler" src={removeIcon} />
  </button>
);

export const Manufacturer = (
  row,
  cell,
  prps,
  getSortArrow,
  editHandler,
  removeHandler,
  editVehicleDialogOpen,
  setEditVehicleDialogOpen,
  editDialogTitle,
  manufacturers
) => {
  const { property, title } = cell;
  const { handleSort, direction, column } = prps;

  return (
    <div className={styles.firstCell}>
      <div onClick={() => handleSort(property)} role="presentation">
        <p className={styles.expandTitle}>
          {i18n.t(title)}
          {getSortArrow(direction, column, property)}
        </p>
        <p className={styles.expandProperty}>{row[property]}</p>
      </div>

      <div className={styles.buttonsSection}>
        <div>
          {RemoveVehicle(row, removeHandler)}
        </div>
        <div>
          {EditVehicle(editDialogTitle, editHandler, editVehicleDialogOpen, setEditVehicleDialogOpen, manufacturers, row)}
        </div>
      </div>
    </div>
  );
};